<template>
  <v-container class="px-0">
    <template>
      <template v-if="!vehicles || vehicles.length === 0">
        <v-col cols="12" class="py-1">
          <v-card>
            <v-card-text>No Vehicles Found</v-card-text>
          </v-card>
        </v-col>
      </template>
      <template v-else>
        <v-col v-for="(vehicle) in vehicles" :key="vehicle.id" cols="12" class="py-1">
          <VehicleSummary :vehicle="vehicle" />
        </v-col>
        <v-col v-if="vehicles.length < totalCount" cols="12">
          <div class="caption text-center px-4">
            <v-btn color="blue2" outlined block @click="getVehicles">Load More</v-btn>
          </div>
        </v-col>
      </template>
    </template>
  </v-container>
</template>

<style scoped>
</style>

<script>
import VehicleSummary from '@/components/Client/LineOfBusiness/Vehicles/VehicleSummary.vue';
import apiService from '@/services/shared/agentPortalApiService.js';
import analyticsService from '@/services/shared/analyticsService.js';

import { mapState, mapActions } from 'vuex';

export default {
  name: 'Vehicles',
  components: {
    VehicleSummary
  },
  data: function () {
    return {
      vehicles: [],
      totalCount: 0,
      loading: true
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    }
  },
  created: async function () {
    this.loading = true;
    await this.getVehicles();
    this.loading = false;
  },
  methods: {
    ...mapActions(['setError']),
    getVehicles: async function () {
      if (this.vehicles.length > 0) {
        analyticsService.sendEvent(this.$gtag, 'Load More', 'Policy', 'Auto Vehicles Load More');
      }
      var rs = await apiService.getLineOfBusinessVehicles(this.clientId, this.policyOrderNumber, this.lobCode, this.vehicles.length);
      if (rs.code === 0) {
        this.totalCount = rs.data[0].totalCount;

        if ((this.vehicles || null) === null) {
          this.vehicles = rs.data[0].data;
        } else {
          this.vehicles = this.vehicles.concat(rs.data[0].data);
        }
      } else {
        this.setError(rs.message);
      }
    }
  }
};
</script>
